import { notificationServiceFactory } from '@ligo/dashboard/store';
import { RESOURCES } from '../resources';

export const NotificationService = notificationServiceFactory(RESOURCES.NOTIFICATION);

